import apiClient from './index'
import type { BudgetEntry, BudgetEntryCreate, BudgetEntryUpdate } from '@/types'
import type { ListQueryParams, BudgetEntryBulkUpsert, BulkOperationResponse } from './types'

const BASE_URL = '/ssp/budget-entries'

export const budgetEntriesApi = {
  getAll: (params?: ListQueryParams) => apiClient.get<BudgetEntry[]>(BASE_URL, { params })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to fetch budget entries:', error)
      throw error
    }),
  getById: (id: number) => apiClient.get<BudgetEntry>(`${BASE_URL}/${id}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to fetch budget entry:', error)
      throw error
    }),
  create: (data: BudgetEntryCreate) => apiClient.post<BudgetEntry>(BASE_URL, data)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to create budget entry:', error)
      throw error
    }),
  update: (id: number, data: BudgetEntryUpdate) => apiClient.put<BudgetEntry>(`${BASE_URL}/${id}`, data)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to update budget entry:', error)
      throw error
    }),
  delete: (id: number) => apiClient.delete<BudgetEntry>(`${BASE_URL}/${id}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to delete budget entry:', error)
      throw error
    }),
  bulkUpdate: (scenarioId: number, updates: BudgetEntryUpdate[]) => apiClient.post<{ updated: number }>(`${BASE_URL}/bulk-update`, { scenario_id: scenarioId, updates })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to bulk update budget entries:', error)
      throw error
    }),
  bulkUpsert: (scenarioId: number, updates: BudgetEntryBulkUpsert[]) => apiClient.post<BulkOperationResponse>(`${BASE_URL}/bulk-upsert`, { scenario_id: scenarioId, updates })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to bulk upsert budget entries:', error)
      throw error
    }),
  copyFromScenario: (sourceScenarioId: number, targetScenarioId: number) => apiClient.post(`${BASE_URL}/copy-from-scenario`, { source_scenario_id: sourceScenarioId, target_scenario_id: targetScenarioId })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to copy budget entries from scenario:', error)
      throw error
    }),
}
